const PictViewClass = require('pict-view');
const libPictSectionOpenSeaDragon = require('pict-section-openseadragon');
const libPictSectionPDFJS = require('pict-section-pdfjs');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class OSDExtended extends libPictSectionOpenSeaDragon
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.osdSettings;

		/** @type {Pict} */
		this.pict;
	}

	customConfigureViewerSettings()
	{
		Object.assign(this.osdSettings,
		{
			zoomInButton: 'osd-zoom-in',
			zoomOutButton: 'osd-zoom-out',
			homeButton: 'osd-home',
		});
	}
}

class ObservationSubImageSelector extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveObservationDetails = {};
		this.ObservationSubImageSelectorBackTo = 'ObservationDetails';
		this.pict.MetaTemplate.addPattern('{~PreviewPages:', '~}', (pHash, pData, fCallback) =>
		{
			const template = /*html*/`
			<div class="has-background-text-40" id="PDFJS-Markup-Container-Div" style="min-width: 100%; height: calc(100vh - 65px - 44px - 56px);" ></div>`;
			return template;
		});
		this.wizardStep = 1;
		this.intent =
		{
			type: 'Document',
		};

		this.registerListenersForPDFViewer();
	}

	renderOSD(tileSources)
	{
		if (this.ActiveObservationDetails.IDObservation)
		{
			const ImageConfiguration =
			{
				ViewIdentifier: 'PictSectionOpenSeaDragonSubImage',
				ViewAddress: 'PictSectionOpenSeaDragonSubImage',
				EnableAnnotation: false,
				PrefixUrl: './images/',
				TileSources: tileSources,
			};
			if (!this.pict.views?.PictSectionOpenSeaDragonSubImage)
			{
				this.pict.addView('PictSectionOpenSeaDragonSubImage', Object.assign(libPictSectionOpenSeaDragon.default_configuration, ImageConfiguration), OSDExtended);
			}
			else
			{
				this.pict.views.PictSectionOpenSeaDragonSubImage.setTileSources(tileSources);
			}
			this.pict.views.PictSectionOpenSeaDragonSubImage.render();
		}
	}

	continue()
	{
		function getClosestZoomLevel(osdZoom, zoomLevels)
		{
			let closestZoomLevel;
			for (let i = 0; i < zoomLevels.length; i++)
			{
				if (zoomLevels[i] >= osdZoom)
				{
					closestZoomLevel = zoomLevels[i];
					break;
				}
			}
			if (!closestZoomLevel)
			{
				closestZoomLevel = zoomLevels[zoomLevels.length - 1];
			}
			return Math.max(1, closestZoomLevel);
		}
		const zoomLevels = [ 0.25, 0.5, 1, 2, 4, 8 ];

		const continueButton = document.getElementById('OSD-SubImageSelector-Continue');
		continueButton.classList.add('is-loading');

		this.pict.providers.ObservationProvider.extractInfoByID(this.ActiveObservationDetails.IDObservation, (extractedInfo) =>
		{
			const pageChoice = this.pict.views.PDFMarkupViewer.getCurrentPage();
			if (pageChoice < 1 || pageChoice > extractedInfo?.pages?.length)
			{
				this.pict.views.HeadlightPanels.toast({
					message: 'You must pick a page number within the document to proceed.',
					type: 'is-danger',
				});
				return;
			}
			this.wizardStep += 1;
			if (this.wizardStep === 2)
			{
				const pageObj = extractedInfo.pages.find((item)=>
				{
					return item.number == pageChoice;
				});
				const generatedTiles = {
					type: 'legacy-image-pyramid',
					levels: [],
				};
				for (const z of zoomLevels)
				{
					generatedTiles.levels.push(
					{
						url: `/1.0/Observation/${ this.ActiveObservationDetails.IDObservation }/Extract/${ encodeURIComponent(`Page:${ pageObj.number };Scale:${ z }`) }`,
						height: pageObj.height * z,
						width: pageObj.width * z,
					});
				}
				this.renderOSD(generatedTiles);
			}
			if (this.wizardStep === 3)
			{
				this.pict.providers.ObservationProvider.extractSubImage(this.ActiveObservationDetails.IDObservation,
				{
					Page: pageChoice,
					Bounds: this.pict.views.PictSectionOpenSeaDragonSubImage.captureViewport(),
					Scale: getClosestZoomLevel(this.pict.views.PictSectionOpenSeaDragonSubImage.viewer.viewport.getZoom(), zoomLevels),
				},
				(obs)=>
				{
					const openAnnotator = () =>
					{
						this.pict.HeadlightPanels.rightPanelResetCustomWidth();
						this.pict.HeadlightPanels.leftPanelResetCustomWidth();
						try
						{
							this.pict.views.ObservationAnnotation.resetObservationAnnotationView();
							this.pict.views.ObservationAnnotation.ActiveObservationDetails = obs;
							this.pict.views.HeadlightPanels.handlePanelToggle('ObservationAnnotation', 'open');
							this.intent =
							{
								type: 'Document',
							};
							this.pict.views['PictFormMetacontroller-DynamicInputs']?.marshalToViewAsync();
							console.log('Opening annotation panel...');
						}
						catch (e)
						{
							console.error(e);
						}
					};
					if (this.intent?.type === 'ObservationSet' && this.intent?.IDObservationSet !== null)
					{
						this.pict.providers.ObservationSetProvider.addObservation(null, obs, this.intent.IDObservationSet).then(() =>
						{
							openAnnotator();
						});
					}
					else
					{
						if (this.AppData?.DocumentData?.ReportData?.IDDocument)
						{
							this.pict.providers.ObservationProvider.joinObservationToDocumentRecord(obs.IDObservation, this.AppData?.DocumentData?.ReportData?.IDDocument, openAnnotator);
						}
						else
						{
							openAnnotator();
						}
					}
				});
			}
			const steps = document.querySelectorAll('#ObservationSubImageSelector-Steps-List li');
			steps.forEach((step, i) =>
			{
				if (i + 1 === this.wizardStep - 1)
				{
					step.classList.add('prev-active');
				}
				else
				{
					step.classList.remove('prev-active');
				}
				if (i + 1 === this.wizardStep)
				{
					step.classList.add('is-active');
				}
				else
				{
					step.classList.remove('is-active');
				}
			});
			const stepBodies = document.querySelectorAll('#OSD-Wizard-Body-Pane > div');
			stepBodies.forEach((stepBody, i) =>
			{
				if (i + 1 === this.wizardStep)
				{
					stepBody.classList.add('is-active');
				}
				else
				{
					stepBody.classList.remove('is-active');
				}
			});
			if (this.wizardStep === 3)
			{
				continueButton.classList.add('is-hidden');
			}
			continueButton.classList.remove('is-loading');
		});
	}

	goHome()
	{
		this.pict.views.PictSectionOpenSeaDragon?.viewer?.viewport?.goHome();
	}

	/**
	 * Toggles the disabled attribute on/off for the passed in elements
	 * @param {Array.<{id:string, title:string}>} elements - {id: id of the element to target, title: tooltip when not disabled }
	 * @param {string} disabledText (optional) - tooltip to display when element is disabled
	 */
	toggleDisabled(elements, disabledText)
	{
		for (const [ key ] of Object.entries(elements))
		{
			const element = elements[key];
			if (!element.hasOwnProperty('id') )
			{
				continue;
			}
			const el = document.getElementById(element.id);

			if (!el)
			{
				continue;
			}

			if (el.hasAttribute('disabled'))
			{
				this.pict.ContentAssignment.removeAttribute(`#${element.id}`, 'disabled');
				if (element.title && typeof element.title === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', element.title );
				}
			}
			else
			{
				this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'disabled', 'disabled');
				if (typeof disabledText === 'string')
				{
					this.pict.ContentAssignment.setAttribute(`#${element.id}`, 'title', disabledText);
				}
			}
		};
	}

	/**
	 * This method resets the state of the Observation Details view to a default state and removes
	 * any active classes on the Image Sets.
	 * @param {boolean} [noIntentReset=false] - If true, the intent will not be reset
	 * @param {boolean} [directPanels=false] - If true, the panels will be directly manipulated
	 * @param {string} [startingPage=undefined] - The page to start at
	 */
	resetObservationSubImageSelectorView(noIntentReset, directPanels, startingPage=undefined)
	{
		this.ActiveObservationDetails = {};
		this.wizardStep = 1;
		this.intent = noIntentReset ? this.intent : { type: 'Document' };
		if (directPanels)
		{
			this.pict.HeadlightPanels.leftPanelCustomWidth(100);
			this.pict.HeadlightPanels.rightPanelTogglePinState('unpin');
			this.pict.HeadlightPanels.rightPanelHide();
		}

		// if caller is requesting we start at a specific page, set. Else, clears the selection.
		this.startingPage = startingPage;
	}

	/**
	 * This method returns the user to the Observation List view and resets the Observation Details view.
	 * This method is called when the user clicks the back button in the Observation Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		this.pict.HeadlightModal.spawnMiniModal(
		{
			...this.pict.HeadlightModal.MiniModalPreset,
			message: 'Return to Observations List?',
		},
		()=>
		{
			this.resetObservationSubImageSelectorView();
			this.pict.HeadlightPanels.rightPanelResetCustomWidth();
			this.pict.HeadlightPanels.leftPanelResetCustomWidth();
			this.pict.views.ObservationDetails.ActiveObservationDetails = this.ActiveObservationDetails;
			this.pict.views.ObservationDetails.returnToPreviousLocation(event, 'ObservationDetails');
			this.pict.views.HeadlightPanels.handlePanelToggle('ObservationSubImageSelector', 'close');
		},
		null);
	}

	/**
	 * This method is used to handle the closing of the Observation Annotation panel.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	handleClosePanelEvent(event)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close Markup Observation Panel?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		},
		null);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		const tmpIDArtifact = this.ActiveObservationDetails?.Details?.File?.[0]?.IDArtifact;
		const tmpVersion = this.ActiveObservationDetails?.Details?.File?.[0]?.Version;
		if (!this.pict.views?.PDFMarkupViewer)
		{
			this.pict.addView('PDFMarkupViewer', Object.assign(libPictSectionPDFJS.default_configuration, { pdfUrl: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`, DefaultDestinationAddress: '#PDFJS-Markup-Container-Div' }), libPictSectionPDFJS);
		}
		if (this.pict.views?.PDFMarkupViewer)
		{
			this.pict.views.PDFMarkupViewer.options.pdfUrl = `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`;
			this.pict.views.PDFMarkupViewer.render();
		}
		return super.onAfterRender(pRenderable);
	}

	/**
	 * TODO: move to the PDFViewer pict section, and allow parent view to inject a page number
	 * TODO: can we do this without the global listener?
	 * @spec listens for the pdf viewer loading. when fully loaded, auto-moves to a specific page if one is requested (i.e. last viewed one)
	 */
	registerListenersForPDFViewer()
	{
		document.addEventListener('webviewerloaded', async () =>
		{
			const viewer = document.querySelector('pdfjs-viewer-element');
			// Wait for the viewer initialization, receive PDFViewerApplication
			const viewerApp = await viewer.initialize();
			// Use event bus to handle viewer application events
			viewerApp.eventBus.on('pagesloaded', () =>
			{
				this.pict.log.info('Viewer pages loaded, startingPage=', this.startingPage);
				if (this.startingPage)
				{
					viewerApp.page = this.startingPage;
				}
			});
		});
		this.pict.log.debug('PDFViewer Handlers registered');
	}

	handleOnCloseEvent(pEvent)
	{
		this.fable.HeadlightModal.spawnMiniModal(
		{
			...this.fable.HeadlightModal.MiniModalPreset,
			message: 'Close Markup Observation Panel?',
		},
		() =>
		{
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.ObservationSubImageSelector.resetObservationSubImageSelectorView();
			this.fable.HeadlightPanels.rightPanelResetCustomWidth();
			this.fable.HeadlightPanels.leftPanelResetCustomWidth();
		});
	}

	handleOnPinPanelEvent(pEvent)
	{
		this.pict.views.ObservationSubImageSelector.toggleDisabled(
		[
			{
				_id: 'ObservationEditSubImage-CloseButton',
				title: 'Close panel',
			},
			{
				_id: 'ObservationEditSubImage-BackButton',
				title: 'Back to Included List view',
			},
		],
		'Please unpin panel');

		this.pict.views.HeadlightPanels.togglePanelPinState();
	}
}

module.exports = ObservationSubImageSelector;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationSubImageSelector',
	DefaultRenderable: 'ObservationSubImageSelector',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'ObservationSubImageSelector-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-ObservationSubImageSelectorPanel" class="panel is-active">
				<p id="HeadlightPanels-ObservationSubImageSelectorPanel-Observation-Header" class="panel-heading pr-4">
					<button id="ObservationEditSubImage-CloseButton" type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" 
						onclick="_Pict.views.ObservationSubImageSelector.handleClosePanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" 
						onclick="_Pict.views.ObservationSubImageSelector.handleOnPinPanelEvent(event)">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-ObservationSubImageSelectorPanel-Observation-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-ObservationSubImageSelectorPanel-Observation-Header-Title" class="mr-3">Create Markup Observation</span>
				</p>
				<div id="HeadlightPanels-ObservationSubImageSelector-Content">
					{~T:ObservationSubImageSelector-Content:Pict.views.ObservationSubImageSelector.ActiveObservationDetails~}
				</div>
			</article>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Content',
			Template: /*html*/`
			<header class="has-background-text-15">
				<ul id="ObservationSubImageSelector-Steps-List" class="wizard-list">
					<li id="OSD-Wizard-Tag-1" class="wizard-step-1 is-active"><div><span>Choose a Page</span></div></li>
					<li id="OSD-Wizard-Tag-2" class="wizard-step-2"><div><span>Select an Image Section</span></div></li>
					<li id="OSD-Wizard-Tag-3" class="wizard-step-3 end-block"><div><span>Annotate</span></div></li>
				</ul>
			</header>
			<div id="OSD-Wizard-Body-Pane">
				<div id="OSD-Wizard-Step-1" class="wizard-pane is-active">
					{~T:ObservationSubImageSelector-Wizard-Step-1:Pict.views.ObservationSubImageSelector.ActiveObservationDetails~}
				</div>
				<div id="OSD-Wizard-Step-2" class="wizard-pane">
					{~T:ObservationSubImageSelector-Wizard-Step-2:Pict.views.ObservationSubImageSelector.ActiveObservationDetails~}
				</div>
				<div id="OSD-Wizard-Step-3" class="wizard-pane">
					{~T:ObservationSubImageSelector-Wizard-Step-3~}
				</div>
			</div>
			<div class="buttons is-right" style="width: 50px; position: absolute; top: calc(100% - 60px); right: 0.5rem;">
				<button id="OSD-SubImageSelector-Continue" title="Continue" onclick="_Pict.views.ObservationSubImageSelector.continue()" 
				style="float: right; margin: 10px;" class="button is-primary has-text-white has-shadow is-normal"><i class="fas fa-fw fa-square-chevron-right" style="margin-right: 5px;"></i>Continue</button>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Wizard-Step-1',
			Template: /*html*/`
			<div class="container panel-content" style="min-width: 100%;" data-observation-id="{~D:Record.IDObservation~}">
				<figure class="image">
					{~PreviewPages:Record~}
				</figure>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Wizard-Step-2',
			Template: /*html*/`
			<div class="container panel-content" data-observation-id="{~D:Record.IDObservation~}" style="min-width: 100%;">
				<div id="OpenSeaDragon-Container-Div" class="open-sea-dragon-content" style="height: calc(100vh - 65px - 44px - 56px); min-width: 100%;"></div>
				<div id="OpenSeaDragon-Navigation-Controls" class="open-sea-dragon-navigation-controls">{~T:ObservationSubImageSelector-Navigation-Controls~}</div>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Wizard-Step-3',
			Template: /*html*/`
			<div class="container panel-content" data-observation-id="{~D:Record.IDObservation~}">
				<div class="p-4">
					<div class="columns is-mobile">
						<div class="column has-text-white">
							<style>
								.lds-ring,
								.lds-ring div {
									box-sizing: border-box;
								}
								.lds-ring {
									display: inline-block;
									position: relative;
									width: 80px;
									height: 80px;
								}
								.lds-ring div {
									box-sizing: border-box;
									display: block;
									position: absolute;
									width: 64px;
									height: 64px;
									margin: 8px;
									border: 8px solid currentColor;
									border-radius: 50%;
									animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
									border-color: currentColor transparent transparent transparent;
								}
								.lds-ring div:nth-child(1) {
									animation-delay: -0.45s;
								}
								.lds-ring div:nth-child(2) {
									animation-delay: -0.3s;
								}
								.lds-ring div:nth-child(3) {
									animation-delay: -0.15s;
								}
								@keyframes lds-ring {
									0% {
										transform: rotate(0deg);
									}
									100% {
										transform: rotate(360deg);
									}
								}
							</style>
							<div class="lds-ring wizard-loader" style="color: white;"><div></div><div></div><div></div><div></div></div>
							<div class="is-size-6 has-text-centered" style="color: white; text-wrap: wrap: max-width: 50vw;">Preparing Image for Annotation...</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationSubImageSelector-Navigation-Controls',
			Template: /*html*/`
			<div class="buttons is-right" style="width: 50px; position: absolute; top: 0.5rem; right: 0.5rem;">
				<button id="osd-zoom-in" title="Zoom in" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-plus"></i>
					</span>
				</button>
				<button id="osd-zoom-out" title="Zoom out"class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-search-minus"></i>
					</span>
				</button>
				<button id="osd-home" title="Original view" class="button is-warning is-rounded has-shadow has-icon-only is-small">
					<span class="icon">
						<i class="fas fa-fw fa-home"></i>
					</span>
				</button>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationSubImageSelector',
			TemplateHash: 'ObservationSubImageSelector-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'ObservationSubImageSelector-Content',
			TemplateHash: 'ObservationSubImageSelector-Content',
			DestinationAddress: '#HeadlightPanels-ObservationSubImageSelector-Content',
			RenderType: 'replace',
		},
	],
};
